<div>
    <p class="noaccess" *ngIf="!userMessage && !isRedirecting">Your user account does not have access to Lab Partner.
    </p>
    <p class="noaccess" *ngIf="userMessage && !isRedirecting" [innerHTML]="userMessage"></p>
    <p *ngIf="isCheckingPermissions">Checking for updated permissions...</p>
    <p *ngIf="isRedirecting && !isFallbackRedirect" class="redirect-message">Permissions found! Redirecting in {{countdown}} seconds...</p>
    <p *ngIf="isRedirecting && isFallbackRedirect" class="redirect-message">Requested page is still unavailable for your account. Redirecting to your home in {{countdown}} seconds...</p>
    <p *ngIf="!isRedirecting" [innerHTML]="contactMessage"></p>

    <!-- Test Mode Login Button -->
    <div *ngIf="environment.testMode" class="test-login-section">
        <h3>Test Mode</h3>
        <p>You are in test mode. Please select a test user to continue:</p>
        <button mat-raised-button color="primary" data-testid="nav-testlogin-button" (click)="showTestLoginDialog()">
            <mat-icon>login</mat-icon>
            Login as Test User
        </button>
    </div>
</div>